import { css } from 'styled-components';
import { Points } from './breakpoints';

const sizes = {
  /*только на главной*/
  h1_first_screen: css`
    font-weight: 200;
    font-size: 28px;
    line-height: 100%;

    @media ${Points.tablet_portrait} {
      font-size: 50px;
    }

    @media ${Points.tablet_landscape} {
      font-size: 30px;
    }

    @media ${Points.laptop} {
      font-size: 36px;
      line-height: 0.9;
    }
  `,
  /*error_stub, title, pricing_page*/
  h1: css`
    font-weight: 200;
    font-size: 28px;
    line-height: 100%;

    @media ${Points.tablet_portrait} {
      font-size: 50px;
    }

    @media ${Points.laptop} {
      font-size: 64px;
    }
  `,
  /*много где*/
  h2: css`
    font-weight: 200;
    font-size: 20px;
    line-height: 100%;

    @media ${Points.tablet_portrait} {
      font-size: 36px;
    }

    @media ${Points.laptop} {
      font-size: 52px;
    }
  `,
  h3: css`
    font-weight: 300;
    font-size: 16px;
    line-height: 100%;

    @media ${Points.tablet_portrait} {
      font-size: 26px;
    }

    @media ${Points.laptop} {
      font-size: 32px;
    }
  `,
  p: css`
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;

    @media ${Points.tablet_portrait} {
      font-size: 18px;
      line-height: 24px;
    }

    @media ${Points.laptop} {
      font-size: 22px;
      line-height: 30px;
    }
  `,
  p_with_spacing: css`
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;

    &:not(:only-child) {
      margin-bottom: 10px;
    }

    @media ${Points.tablet_portrait} {
      font-size: 18px;
      line-height: 24px;

      &:not(:only-child) {
        margin-bottom: 20px;
      }
    }

    @media ${Points.laptop} {
      font-size: 22px;
      line-height: 30px;
    }
  `,
  p2: css`
    font-weight: 300;
    font-size: 13px;
    line-height: 16px;

    @media ${Points.tablet_portrait} {
      font-size: 15px;
      line-height: 18px;
    }

    @media ${Points.laptop} {
      font-size: 16px;
      line-height: 19px;
    }
  `,
  p3: css`
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;

    @media ${Points.tablet_portrait} {
      font-size: 13px;
      line-height: 16px;
    }

    @media ${Points.laptop} {
      font-size: 14px;
      line-height: 17px;
    }
  `,
  p1_long_with_spacing: css`
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;

    &:not(:only-child) {
      margin-bottom: 4px;
    }

    @media ${Points.tablet_portrait} {
      font-size: 18px;
      line-height: 28px;

      &:not(:only-child) {
        margin-bottom: 8px;
      }
    }

    @media ${Points.laptop} {
      font-size: 22px;
      line-height: 36px;

      &:not(:only-child) {
        margin-bottom: 12px;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  `,
  requirements_header: css`
    font-size: 24px;
    line-height: 1.2;

    @media ${Points.laptop} {
      font-size: 30px;
      line-height: 1.08;
    }

    @media ${Points.fullhd} {
      font-size: 36px;
      line-height: 1;
    }
  `,
  faq_description: css`
    font-size: 14px;
    line-height: 1.115;

    @media ${Points.tablet_portrait} {
      font-size: 12px;
    }

    @media ${Points.laptop} {
      font-size: 14px;
    }

    @media ${Points.fullhd} {
      font-size: 16px;
    }
  `,
  list_header: css`
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;

    @media ${Points.tablet_portrait} {
      font-size: 20px;
      line-height: 28px;
    }

    @media ${Points.laptop} {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  footerLink: css`
    font-size: 12px;
    line-height: 14px;

    @media ${Points.tablet_portrait} {
      font-size: 14px;
      line-height: 17px;
    }

    @media ${Points.laptop} {
      font-size: 18px;
      line-height: 22px;
    }
  `,
  /*Тарифы*/
  table_header: css`
    font-size: 16px;
    line-height: 1.3;

    @media ${Points.laptop} {
      font-size: 18px;
      line-height: 1.17;
    }

    @media ${Points.fullhd} {
      font-size: 20px;
      line-height: 1.3;
    }
  `,
  /*Новый стиль, заменяет h1_download - X*/
  page_header: css`
    font-size: 36px;
    line-height: 1;

    @media ${Points.tablet_landscape} {
      font-size: 48px;
    }

    @media ${Points.laptop_wide} {
      font-size: 66px;
    }

    @media ${Points.fullhd} {
      font-size: 80px;
      line-height: 72px;
    }
  `,
  /*Вместо h1_new - X*/
  block_header: css`
    font-size: 28px;
    line-height: 1.1;

    @media ${Points.tablet_landscape} {
      font-size: 34px;
    }

    @media ${Points.laptop_wide} {
      font-size: 44px;
      line-height: 1;
    }

    @media ${Points.fullhd} {
      font-size: 54px;
    }
  `,
  /*новый заг, может вместо features_header - Х*/
  factoid_large_header: css`
    font-size: 26px;
    line-height: 1.1;

    @media ${Points.tablet_landscape} {
      font-size: 30px;
      line-height: 1;
    }

    @media ${Points.laptop_wide} {
      font-size: 40px;
    }

    @media ${Points.fullhd} {
      font-size: 50px;
    }
  `,
  /*вместо h2_new - X*/
  large_card_header: css`
    font-size: 22px;
    line-height: 1.1;

    @media ${Points.tablet_landscape} {
      font-size: 24px;
      line-height: 1.2;
    }

    @media ${Points.laptop_wide} {
      font-size: 30px;
      line-height: 1.08;
    }

    @media ${Points.fullhd} {
      font-size: 36px;
      line-height: 1;
    }
  `,
  /*новый, вместо header_4 - X, h3_blog - X, trial_text - X*/
  card_header: css`
    font-size: 20px;
    line-height: 1.2;

    @media ${Points.tablet_landscape} {
      font-size: 22px;
      line-height: 1.1;
    }

    @media ${Points.laptop_wide} {
      font-size: 24px;
    }

    @media ${Points.fullhd} {
      font-size: 30px;
    }
  `,
  /*Новый заг, вместо h3_interview - X, strong - X, description_old - X*/
  subtitle: css`
    font-size: 18px;
    line-height: 1.1;

    @media ${Points.laptop_wide} {
      font-size: 20px;
    }

    @media ${Points.fullhd} {
      font-size: 24px;
    }
  `,
  /*Вместо body_main - X, вместо quote_with_spacing - X, quote - X*/
  body: css`
    font-size: 16px;
    line-height: 1.3;

    @media ${Points.fullhd} {
      font-size: 18px;
    }
  `,
  /*Новый заг, вместо p_blog*/
  article: css`
    font-size: 18px;
    line-height: 1.3;

    @media ${Points.fullhd} {
      font-size: 20px;
    }
  `,
  /*Новый заг, вместо opportunities_header - Х*/
  accent: css`
    font-size: 28px;
    line-height: 1.1;

    @media ${Points.tablet_landscape} {
      font-size: 32px;
    }

    @media ${Points.laptop_wide} {
      font-size: 48px;
    }

    @media ${Points.fullhd} {
      font-size: 55px;
    }
  `,
  /*Вместо description_new - X, features - X, date_mark - Х, breadcrumbs - X, copyright - X*/
  description: css`
    font-size: 14px;
    line-height: 1.2;

    @media ${Points.fullhd} {
      font-size: 16px;
      line-height: 1.1;
    }
  `,
  /*Новый, актуальный*/
  description_2: css`
    font-size: 12px;
    line-height: 1.1;

    @media ${Points.fullhd} {
      font-size: 14px;
    }
  `,
  /*Новый заг вместо footerMenu - X*/
  footer_txt: css`
    font-size: 14px;
    line-height: 1.1;

    @media ${Points.tablet_landscape} {
      font-size: 16px;
    }

    @media ${Points.fullhd} {
      font-size: 18px;
    }
  `,
  /*Новый заг вместо footerTitle - X*/
  footer_header: css`
    font-size: 14px;
    line-height: 1.115;
  `,
};

export const textSize = (size = 'h1') => {
  const value = sizes[size];

  if (value) {
    return value;
  } else {
    console.error(`${size} - This text size is not available`);
    return '';
  }
};
